module.exports = __webpack_public_path__ + "static/media/ball_clevis.2ff00b15.webp";